import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { withRouter } from 'react-router-dom';
import { FormattedMessage, intlShape, injectIntl } from 'react-intl';
import { withLastLocation } from 'react-router-last-location';

import ChipInput from 'material-ui-chip-input';

import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import Hidden from '@material-ui/core/Hidden';

import { bindActionCreators } from 'redux';
import * as actions from '../../actions/process.home.actions';

import { MenuIcon, ArrowBackIcon, SearchIcon } from '../../images/icons/WrapSvg';
import Menu from './user/Menu';

// eslint-disable-next-line
import style from './_styles.css';

class MenuAppBar extends React.Component {
    
    state = {
        auth: true,
        anchorEl: null,
        showSearch: this.props.search,
        searchs: this.props.window_searchs
    };

    static getDerivedStateFromProps(props, state) {
        if (
            props.window_searchs !== state.searchs ||
            props.search !== state.showSearch
        ) {
            state.showSearch = props.search;
            state.searchs = props.window_searchs;
            return state;
        }
        return null; 
    }

    searchBar = () => {
        return (
            <div className="flex_full_row">
                <ChipInput
                    name="ChipInput"
                    fullWidth
                    placeholder={this.props.intl.formatMessage({ id: 'search' })}
                    value={this.state.searchs}
                    onAdd={(chip) => this.handleAddChip(chip)}
                    onDelete={(chip, index) => this.handleDeleteChip(chip, index)}
                    classes={{
                        chip: 'barlow_regular_smalltext c_white bg_bluish margin_top_9',
                        root: 'barlow_regular_smalltext c_cool_grey_two',
                        inputRoot: 'padding_top_12',
                    }}
                />
            </div>
        );
    };

    handleAddChip = (chip) => {
        const arr = [...this.state.searchs];
        arr.push(chip.toUpperCase());
        this.props.searchArray(arr);
        this.setState({ searchs: arr });
    };

    handleDeleteChip = (chip, index) => {
        const arr = [...this.state.searchs];
        arr.splice(index, 1);
        this.props.searchArray(arr);
        this.setState({ searchs: arr });
    };

    handelClick = (name, value) => (event) => {
        this.setState({ [name]: value });
    };

    handleChange = (event, checked) => {
        this.setState({ auth: checked });
    };

    handleMenu = () => {
        console.log('click menu');
        this.setState({ anchorEl: true });
    };

    handleClose = () => {
        this.setState({ anchorEl: null });
    };

    handleBack = () => {
        /*
        let path = this.props.history.location.pathname.split('/');
        path.splice(path.length - 1, 1);
        path = path.join('/');
        this.props.history.push(path);
        */
        if(this.props.lastLocation && this.props.lastLocation.pathname === "/user/login") {
            this.props.history.push("/");
        } else {
            this.props.history.goBack();
        }
    }

    render() {
        const { anchorEl, showSearch } = this.state;
        const { title, param, prominent, noprominent, back, search, caption, tools } = this.props;
        const labelTitle = param ? <span>{caption} </span> : <FormattedMessage id={title} />;
        return (
            <div className="flex_grow_1">
                <AppBar
                    color="default"
                    className={classNames(
                        'position_relative',
                        prominent && noprominent === undefined && !showSearch
                            ? 'prominent'
                            : 'bg_white',
                    )}
                >
                    <Toolbar>
                        {back ? (
                            <ArrowBackIcon
                                className={'menuButton'}
                                color="primary"
                                onClick={this.handleBack}
                            />
                        ) : (
                                <MenuIcon
                                    className={'menuButton'}
                                    color="primary"
                                    aria-label="Menu"
                                    onClick={this.handleMenu}
                                />
                            )}
                        <Hidden smUp>
                            {prominent && noprominent === undefined && !showSearch ? (
                                <div className="flex_full_row text_align_right" />
                            ) : showSearch ? (
                                this.searchBar()
                            ) : (
                                        <div className="flex_full_row align_center">
                                            <span className="barlowsemicondensed_bold c_dark_grey_blue uppercase">
                                                {labelTitle}
                                            </span>
                                        </div>
                                    )}
                        </Hidden>
                        <Hidden xsDown>
                            <div className="flex_full_row">
                                <div className="flex_full_row">
                                    {!showSearch ? (
                                        <span className="barlowsemicondensed_bold c_dark_grey_blue uppercase">
                                            {labelTitle}
                                        </span>
                                    ) : (
                                            this.searchBar()
                                        )}
                                </div>
                            </div>
                        </Hidden>
                        <div className="display_toolbar">
                            {search && (
                                <SearchIcon
                                    className={'icon hand'}
                                    color="primary"
                                    onClick={this.handelClick('showSearch', !showSearch)}
                                />
                            )}
                            {tools &&
                                tools.length > 0 &&
                                tools.map((t) => {
                                    return t;
                                })}
                        </div>
                        <div>
                            {anchorEl && (
                                <Menu
                                    id="menu-appbar"
                                    anchorEl={anchorEl}
                                    anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
                                    transformOrigin={{ vertical: 'top', horizontal: 'right' }}
                                    onClose={this.handleClose}
                                />
                            )}
                        </div>
                    </Toolbar>
                    <Hidden smUp>
                        {prominent && noprominent === undefined && !showSearch ? (
                            <div className={'subTitle'}>
                                <span className="barlowsemicondensed_bold c_dark_grey_blue uppercase">
                                    {labelTitle}
                                </span>
                            </div>
                        ) : (
                                <div />
                            )}
                    </Hidden>
                </AppBar>
            </div>
        );
    }
}

MenuAppBar.propTypes = {
    prominent: PropTypes.bool.isRequired,
    search: PropTypes.bool.isRequired,
    filter: PropTypes.bool.isRequired,
    tools: PropTypes.array.isRequired,
    intl: intlShape.isRequired,
    window_searchs: PropTypes.array.isRequired,
};

function mapStateToProps(state) {
    return {
        prominent: state.window.prominent,
        caption: state.window.title,
        search: state.window.search,
        filter: state.window.filter,
        tools: state.window_tools,
        window_searchs: state.window_searchs,
    };
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators(Object.assign({}, actions), dispatch);
}

export default connect(
    mapStateToProps,
    mapDispatchToProps,
)(withLastLocation(withRouter(injectIntl(MenuAppBar))));



// WEBPACK FOOTER //
// ./src/components/navbar/MenuAppBar.js